import moment from 'moment';
import isArray from 'lodash/isArray';
import isEmail from 'sane-email-validation';

export const DATETIME_FORMAT = 'MM/DD/YYYY HH:mm';

export const validateRequired = (v) => {
  const errorMsg = "Please enter a value.";

  if (typeof(v) === "string") {
    return v.trim().length === 0? errorMsg : undefined;
  }

  if (typeof(v) === "number") {
    return undefined;
  }

  if (isArray(v)) {
    return v.length === 0? errorMsg : undefined;
  }

  return !v? errorMsg : undefined;
}

export const validateDatetime = (v) => {
  /* ignore if `v` is empty */
  if (validateRequired(v)) {
    return;
  }

  const obj = moment(v, DATETIME_FORMAT);

  if (!obj.isValid()) {
    return 'Please enter a valid date and time.';
  }
}

export const validateEmail = (v) => {
  /* ignore if `v` is empty */
  if (validateRequired(v)) {
    return;
  }

  if (!isEmail(v)) {
    return 'Please enter a valid email.';
  }
}
